import React from 'react';
import topCoins  from '../../images/market/topCoins.png';
import topGems  from '../../images/market/topGems.png';
import coins from '../../images/market/coin-box.svg'
import gems from '../../images/market/gems.png'
const Score = ({overlay}) => {
  return (
    <div className='top-div'>
      <div className="score-div first-score">
        <img src={topCoins} alt=""/>
        <div className="body">
          <span>Coins</span>
          {/* <p>0</p> */}
        </div>
       
      </div>
       <div className={`${!overlay ? 'sub-detail': ''} coins-detail`}>
          <img src={coins} alt=""/>
          <p>Coins</p>
          <p>Coins act as main in-game currency required to perform activities like participating in battles, creating potions, feeds and others in the Monsters Clan.
</p>
          {/* <button className="btn buy">Buy Now</button> */}
        </div>
      <div className="score-div sec-score">
        <img src={topGems} alt=""/>
        <div className="body">
          <span>Gems</span>
          {/* <p>0</p> */}
        </div>
        <div className={`${!overlay ? 'sub-detail': ''} gems-detail`}>
          <img src={gems} alt=""/>
          <p>Gems</p>
          <p>Gems act as a special currency within Monsters Clan, you
            can use gems to perform special activities like speeding up
            potion generation process, feed creation, and many other
            special operations in the game.</p>
          {/* <button className="btn buy">Buy Now</button> */}
        </div>
      </div>
    </div>
  )
}
export default Score;